import { Option } from 'components/common/types/DropdownItem.types';

export const getFilteredOptions = (options: Option[], search: string): Option[] => {
  const filteredOptions: Option[] = [];

  options.forEach((option) => {
    const { name, children } = option;

    if (name.toLowerCase().includes(search.toLowerCase())) {
      filteredOptions.push(option);
    } else if (children) {
      const childFilteredOptions = getFilteredOptions(children, search);

      if (childFilteredOptions.length) {
        filteredOptions.push({ ...option, children: childFilteredOptions });
      }
    }
  });

  return filteredOptions;
};

export const filterOptions = (options: Option[], search: string): Option[] => {
  if (!search || search.length < 3) return options;

  return getFilteredOptions(options, search);
};
